export default [
    {
        type: "mesh",
        vertices: [
            -376, 189, 42, 230, 223, -310, 353, 162, -62, 414, -23, -67, 256, 90, -475, 24, 85, -526, -418, -16, 57,
            -432, 66, -40, -199, 151, -376, -155, 49, 467, -91, 289, 201, 293, 197, 91, 81, -17, -480, 42, 108, 431,
            -359, -17, -250, 383, -19, -243, 194, -15, 270, -272, 180, 293, -86, 212, 262, 234, 54, 297, 395, 97, -302,
            -123, -21, -444, -416, -19, -123, -323, -18, 267, -100, -16, 429, -300, 96, -361, 163, -19, 409, 118, 201,
            -431, -241, -18, 391, -130, 274, -309, 306, -19, -399, -221, 96, 404,
        ],
        faces: [
            31, 18, 17, 0, 17, 18, 3, 20, 2, 18, 11, 10, 29, 27, 8, 27, 29, 1, 0, 18, 10, 10, 29, 0, 16, 19, 26, 11, 2,
            1, 20, 30, 4, 20, 3, 15, 30, 12, 4, 4, 12, 5, 5, 27, 4, 4, 27, 20, 21, 25, 5, 7, 8, 25, 22, 7, 14, 7, 25,
            14, 23, 28, 31, 0, 7, 17, 24, 26, 9, 31, 28, 9, 8, 27, 5, 2, 20, 1, 13, 19, 18, 10, 11, 1, 19, 13, 26, 3,
            11, 19, 19, 16, 3, 11, 3, 2, 11, 18, 19, 20, 15, 30, 29, 10, 1, 25, 21, 14, 8, 5, 25, 5, 12, 21, 6, 7, 22,
            7, 6, 23, 8, 0, 29, 8, 7, 0, 23, 31, 7, 13, 31, 9, 18, 31, 13, 9, 28, 24, 26, 13, 9, 27, 1, 20, 7, 31, 17,
        ],
    },
    {
        type: "mesh",
        vertices: [
            -217, 34, -153, 198, 90, 20, 212, 85, 169, -131, 93, 171, 197, 113, 30, 173, 121, 164, 315, 29, -16, 219,
            24, 189, 282, 50, -102, 232, 38, -181, -195, -9, -166, -156, 30, -207, -51, -9, -231, -180, 91, -173, -19,
            73, -204, -280, 23, 96, -242, 100, 107, 3, 158, -82, 109, 88, 221, 275, -10, -40, 236, -10, -135, -178, 49,
            184, -1, -10, -243, 265, -11, 109, -12, -9, 237, -36, 46, 251, -233, 86, -81, 93, 77, -171, -163, 133, 69,
            18, 16, 263, 296, 44, 93, 131, -12, -226, -89, -10, -201, -273, -10, -51, -240, -9, 110, 190, -12, 192,
            -253, -11, -92, 42, 43, -258, -115, -11, 238, 168, 99, -88, -285, -10, 24, 71, 124, -158, 298, -10, 10, 116,
            150, -24, -282, 44, 39,
        ],
        faces: [
            44, 16, 26, 13, 26, 16, 0, 26, 13, 27, 14, 41, 4, 5, 1, 7, 30, 2, 28, 5, 43, 41, 39, 27, 17, 43, 41, 43, 4,
            39, 13, 28, 17, 17, 41, 13, 28, 43, 17, 24, 29, 38, 29, 35, 7, 18, 25, 29, 5, 18, 2, 18, 5, 3, 30, 42, 6,
            30, 35, 23, 19, 20, 8, 8, 20, 9, 9, 39, 8, 1, 30, 8, 31, 37, 9, 11, 14, 37, 14, 27, 37, 32, 11, 12, 11, 37,
            12, 11, 0, 13, 33, 40, 44, 44, 26, 33, 33, 0, 36, 34, 38, 15, 44, 40, 15, 21, 3, 16, 27, 39, 9, 2, 30, 1,
            21, 25, 3, 16, 3, 28, 28, 3, 5, 4, 43, 5, 41, 43, 39, 13, 16, 28, 25, 21, 38, 38, 29, 25, 7, 18, 29, 29, 24,
            35, 18, 7, 2, 18, 3, 25, 30, 23, 42, 30, 7, 35, 8, 30, 6, 6, 19, 8, 6, 42, 19, 8, 39, 1, 37, 31, 22, 27, 9,
            37, 9, 20, 31, 10, 11, 32, 11, 10, 0, 12, 37, 22, 14, 13, 41, 14, 11, 13, 33, 26, 0, 36, 0, 10, 21, 44, 15,
            16, 44, 21, 15, 40, 34, 38, 21, 15, 4, 1, 39, 5, 2, 1,
        ],
    },
    {
        type: "mesh",
        vertices: [
            -101, 102, 57, 99, 35, 102, 40, 72, 80, 59, 14, -168, -186, 22, 45, -176, 25, -30, 66, -7, 146, 153, -7, 53,
            -110, 47, -96, -90, -8, -146, 150, -7, -12, -200, -7, 8, -173, -7, -55, 55, 46, -60, 125, -7, 110, 136, 30,
            -10, -149, 58, 68, -15, 82, -71, 98, -7, -86, -34, -6, -194, -33, -7, 171, -36, 65, 137, 38, -8, -192, -103,
            -9, 147, -12, 62, -152,
        ],
        faces: [
            2, 17, 0, 17, 8, 0, 17, 24, 8, 19, 24, 22, 5, 11, 4, 2, 13, 17, 17, 13, 24, 21, 23, 20, 1, 2, 21, 7, 15, 1,
            7, 10, 15, 5, 9, 12, 15, 18, 13, 0, 5, 16, 0, 8, 5, 1, 15, 2, 10, 18, 15, 3, 13, 18, 24, 3, 22, 11, 23, 4,
            4, 16, 5, 16, 4, 23, 24, 13, 3, 15, 13, 2, 6, 1, 21, 6, 21, 20, 6, 14, 1, 2, 0, 21, 1, 14, 7, 3, 18, 22, 8,
            24, 19, 8, 19, 9, 12, 11, 5, 5, 8, 9, 16, 23, 21, 16, 21, 0,
        ],
    },
    {
        type: "mesh",
        vertices: [
            86, 55, -18, 58, 38, 73, 97, -12, 79, 135, 7, 10, -93, -11, -72, -133, 5, 33, 13, 68, -32, 94, -11, -57,
            -90, 52, 53, -24, -11, -106, -13, -10, 104, -75, 49, -69, -12, 18, 114, 49, -12, -96, -46, -11, -85, -119,
            -11, -26, 48, 5, -111, -58, -11, 105, -117, -12, 52, -5, 35, -93, 123, -11, 7,
        ],
        faces: [
            5, 8, 11, 2, 3, 1, 8, 1, 6, 11, 8, 6, 6, 19, 11, 10, 12, 17, 20, 7, 3, 3, 7, 16, 16, 0, 3, 16, 9, 19, 14, 4,
            9, 15, 18, 5, 5, 11, 15, 18, 17, 5, 19, 0, 16, 1, 3, 0, 0, 6, 1, 19, 6, 0, 12, 8, 17, 2, 1, 12, 12, 10, 2,
            1, 8, 12, 3, 2, 20, 16, 13, 9, 16, 7, 13, 19, 4, 11, 15, 11, 4, 17, 8, 5, 9, 4, 19,
        ],
    },
];
